import React from 'react';
import { useSelector } from 'react-redux';
import logo from '../../../assests/logo.png'
import Support from '../../../shared/components/features/support/Support';
import UserProfile from '../../../shared/components/features/userProfile/UserProfile';
import Icon from '../../../shared/components/ui/icons/Icon';
import iconsList from '../../../shared/components/ui/icons/iconsList';
import classes from './Header.module.css';

const Header = () => {

    const { texts, lang } = useSelector(state => state.translate);
    const { user, userDetails } = useSelector(state => state.auth);
    const accessibilityLink = useSelector(state => state?.uiData?.general?.accessibilityLink)

    return (
        <div className={classes.Header}>
            <div className={classes.Text}>
                <img src={logo} alt='logo' />
                <p className={classes.Title}>{texts.virtualSchool}</p>
                <p className={classes.SchoolName}>- {userDetails?.defaultSchool?.name}</p>
            </div>

            <div className={classes.UserName}>
                <Support />
                <Icon name={iconsList.accessibility} size="26px" color="#979797" className={classes.linkIcon} accessibilityDescription={texts.accessibilityStatementLink} onClick={() => window.open(accessibilityLink?.[lang], '_blank', 'noopener,noreferrer')} />
                <p>{texts.hello} {user?.name} </p>
                <div className={classes.UserProfile}>
                    <UserProfile />
                </div>
            </div>

        </div>
    )
}
export default Header;